// extracted by mini-css-extract-plugin
export default {"body":"Footer_body__pVer5","footer-holder":"Footer_footer-holder__iwOzF","copyright":"Footer_copyright__JQMtz"};